import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InformationRoutingModule } from "./information.routing";
import { InformationComponent } from "./information.component";
import { WorldTravelPopUpComponent } from "./world-travel-detail.popup.component";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';


@NgModule({
  declarations: [
    InformationComponent,
    WorldTravelPopUpComponent
  ],
  imports: [InformationRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, CommonModule, InfiniteScrollModule],
  entryComponents: [WorldTravelPopUpComponent],
  providers: [],
  bootstrap: []
})
export class InformationModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/information/information.module.ts